document.addEventListener('DOMContentLoaded', function () {
  var experienceSections = document.querySelectorAll('.om-experiences');

  if (!experienceSections.length) return;

  experienceSections.forEach(function (section) {
    var links = Array.from(section.querySelectorAll('.om-experiences__micro-link'));
    var items = Array.from(section.querySelectorAll('.om-experience[id]'));
    var indicator = section.querySelector('.om-experiences__micro-indicator');

    if (!links.length || !items.length) return;

    function setActiveLink(id) {
      var activeLink = null;

      links.forEach(function (link) {
        var target = link.getAttribute('data-target') || '';
        var isActive = target === id;
        link.classList.toggle('is-active', isActive);
        if (isActive) activeLink = link;
      });

      updateIndicator(activeLink);
    }

    function updateIndicator(activeLink) {
      if (!indicator || !activeLink) return;

      var nav = activeLink.parentElement;
      if (!nav) return;

      var navRect = nav.getBoundingClientRect();
      var linkRect = activeLink.getBoundingClientRect();

      var left = linkRect.left - navRect.left + nav.scrollLeft;
      var width = linkRect.width;

      indicator.style.transform = 'translateX(' + left + 'px)';
      indicator.style.width = width + 'px';
      indicator.style.opacity = '0.72';
    }

    function getCurrentSection() {
      var currentId = items[0].id;

      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.35) {
          currentId = item.id;
        }
      });

      return currentId;
    }

    function updateActiveState() {
      var currentId = getCurrentSection();
      setActiveLink(currentId);
    }

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        var targetId = link.getAttribute('data-target') || '';
        if (targetId) {
          setActiveLink(targetId);
        }
      });
    });

    updateActiveState();
    window.addEventListener('scroll', updateActiveState, { passive: true });
    window.addEventListener('resize', updateActiveState);
  });
});